module.exports = __webpack_public_path__ + "img/qy.3d09fc72.png";